import { useState, createContext } from "react";
import React from 'react';

const initialData = {
  specialty: "",
  city: "",
  tenancyTyp:"",
};
// Due to new version migration (16 -> 19) changed react.createContext to createContext.
export const FilterSearchContext = createContext({
  searchBoxData: initialData,
  updateSearchBoxData: () => {},
});

export const FilterSearchProvider = ({ children }) => {
  const [searchBoxData, setSearchBoxData] = useState(initialData);
  const updateSearchBoxData = (data) => {
    setSearchBoxData((prev) => ({ ...prev, ...data }));
  };
  return (
    <FilterSearchContext.Provider
      value={{
        searchBoxData,
        updateSearchBoxData,
      }}
    >
      {children}
    </FilterSearchContext.Provider>
  );
};
